import React from 'react';
import { Icon, notification } from '@ss/mtd-react';
import { Upload as BlockUpload } from '@block/plug';
import classnames from 'classnames';
import FileList from '../FileList';
import './index.scss';

const { helper } = BlockUpload;

interface Props extends DefaultToFormItem {
  value?: string;
  url?: any;
  fileType?: string;
  size?: number;
  onChange?: (e?: any) => void;
  onParseUrlFromResponse?: any;
  label?: string;
  isPhoto?: boolean;
  subtitle?: string;
  needMoreHeight?: boolean;
  mode?: 'view' | 'edit';
}

interface State {
  loading: boolean;
  value: string;
}
class Upload extends React.Component<Props, State> {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      value: null, // 图片展示地址
    };
  }

  // static getDerivedStateFromProps(nextProps, prevState) {
  //   const { value } = nextProps;
  //   console.error('value', prevState);
  //   // 当传入的type发生变化的时候，更新state
  //   if (value !== prevState.photoUrl) {
  //     return {
  //       photoUrl: value,
  //     };
  //   }
  //   // 否则，对于state不进行任何操作
  //   return null;
  // }
  componentDidMount() {
    const { value } = this.props;
    this.setState({ value });
  }

  componentWillReceiveProps(nextProps) {
    const { value } = nextProps;
    const { value: propsValue } = this.props;
    if (value !== propsValue) {
      this.setState({
        value,
      });
    }
  }

  handleValidateFileType = (file, accepted) => {
    const fileExt = (/^.*\.(.*)$/.exec(file.name) || ['', ''])[1].toLowerCase();
    const valid = accepted.includes(fileExt);
    if (!valid) {
      notification.error({
        message: `不支持上传非 ${accepted.join('、')}格式文件，请重新上传`,
      });
    }
    return valid;
  };

  handleValidateFileSize = (file, size) => {
    const valid = file.size / 1024 <= size * 1024;
    if (!valid) {
      notification.error({
        message: `文件大小超过${size}M,请重新上传`,
      });
    }
    return valid;
  };

  handleUpload = (file) => {
    const { url, fileType, size } = this.props;
    const type = fileType || ['png', 'jpeg', 'jpg', 'bmp'];
    const photoSize = size || 20;
    this.setState({
      loading: true,
    });
    if (!this.handleValidateFileType(file, type) || !this.handleValidateFileSize(file, photoSize)) {
      this.setState({
        loading: false,
      });
      return false;
    }

    helper.upload(url, file, {
      params: {},
      onSuccess: (res) => {
        const { fileUrl } = res;
        const { onChange, onParseUrlFromResponse } = this.props;
        const adapterUrl = (onParseUrlFromResponse && onParseUrlFromResponse(res)) || fileUrl;
        onChange && onChange(res || {});
        this.setState({
          loading: false,
          value: adapterUrl,
        });
      },
      onError: (err) => {
        this.setState({
          loading: false,
        });
        notification.error({
          message: err.message || '上传失败',
        });
      },
    });
    return null;
  };

  handleRemove = () => {
    this.setState({
      value: null,
    });
    const { onChange } = this.props;
    onChange && onChange({});
  };

  render() {
    const {
      label,
      isPhoto,
      subtitle,
      needMoreHeight = false,

      // 默认edit，兼容其他已存场景
      mode = 'edit',
    } = this.props;
    const { loading, value } = this.state;
    return (
      <div className={classnames('upload', needMoreHeight ? 'moreHeightUpload' : '')}>
        {value ? (
          <div className={classnames('upload__content', isPhoto ? 'upload__photo' : '')}>
            <FileList url={value} onRemove={this.handleRemove} mode={mode} />
          </div>
        ) : (
          <BlockUpload
            className={classnames(
              'upload__content',
              isPhoto ? 'upload__photo' : '',
              needMoreHeight ? 'moreHeightUpload__content' : '',
            )}
            multiple={false}
            onUpload={this.handleUpload}
          >
            <div className="upload__wrapper">
              <Icon className="upload__icon" type="add" />
              <div className="upload__text">{loading ? '上传中...' : label || '上传图片'}</div>
              <div className="upload__subtitle">{subtitle}</div>
            </div>
          </BlockUpload>
        )}
      </div>
    );
  }
}

export default Upload;
